import { useColorScheme } from '@mui/material';
import SwerveIcon from '../../Drawers/assets/Swerve_simplified.svg';

interface DUOrientationSVGProps {
  angle: number;
}

const DUOrientationSVG = ({ angle }: DUOrientationSVGProps) => {
  const { mode, systemMode } = useColorScheme();
  let colorMode = mode;
  if (mode === 'system') {
    colorMode = systemMode;
  }

  const SIZE = 100; // Container size

  const robotWidth = SIZE * 0.7;
  const robotHeight = SIZE * 0.7;
  const robotXY = (SIZE - robotWidth) / 2;

  const cx = SIZE / 2;
  const cy = SIZE / 2;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="100%"
      height="100%"
      viewBox={`0 0 ${SIZE} ${SIZE}`}
      fill="none"
    >
      <g transform={`rotate(${-angle}, ${cx}, ${cy})`}>
        <image
          href={SwerveIcon}
          x={robotXY}
          y={robotXY}
          width={robotWidth}
          height={robotHeight}
          preserveAspectRatio="xMidYMid meet"
          style={{
            filter: colorMode === 'dark' ? 'brightness(0) invert(1)' : 'none',
          }}
        />
      </g>
    </svg>
  );
};
export default DUOrientationSVG;
